export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["EnableResourceFreezing"] = "enable_resource_freezing";
    FeatureFlag["UpdateClientLabelInShareFile"] = "update_client_label_in_sharefile";
    FeatureFlag["EnableAutomationPermissions"] = "enable_automation_permissions";
    FeatureFlag["UsePagedQueryByTags"] = "use_paged_query_by_tags";
    FeatureFlag["EnableProjectsVirtualList"] = "enable_projects_virtual_list";
    FeatureFlag["EnableProjectCreationWithESign"] = "enable_project_Esign";
    FeatureFlag["DisableLegacyRoles"] = "disable_legacy_roles";
})(FeatureFlag || (FeatureFlag = {}));
//# sourceMappingURL=featureFlags.js.map